import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Father from "../../assets/images/father.jfif";
import './products-item.css'
import { Skeleton } from 'primereact/skeleton';
import EmptyCard from '../../assets/images/empty-card.svg';


//Api
import { getProductsBySearch, imgBaseUrl } from '../../utils/api'
import { CartProvider } from '../../contexts/CartContext';

const ProductsItem = ({ categoryId }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // وضعیت برای لودینگ
  const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
  const [loaded, setLoaded] = useState(false);

  const settings = {
    rtl: true,
    infinite: products.length > 5,
    arrows: products.length > 5,
    autoplay: true, // Enable auto-sliding
    autoplaySpeed: 3000, // Interval for auto-slide (in milliseconds)
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchProducts = async () => {
      if (categoryId) {
        setLoading(true);
        try {
          let pay = {
            categoryId: categoryId.value,
            productTitle: categoryId.text
          }
          const res = await getProductsBySearch(pay);
          setProducts(res.data.data.items);
          setLoading(false);

        } catch (error) {
          console.error('Error fetching products:', error);
        }
        finally {
          setLoading(false); // اتمام بارگذاری
        }
      }
    };

    fetchProducts();
  }, [categoryId]);

  const handleMouseDown = () => setIsScrolling(false);
  const handleMouseMove = () => setIsScrolling(true);
  const handleMouseUp = (productId) => {
    if (!isScrolling) {
      window.location.href = `/productDetail?productId=${productId}`;
    }
  };
  function convertToPersianNumbers(input) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return input.replace(/\d/g, (digit) => persianDigits[digit]);
  }
  
  return (
    <>
      {products.length === 0 ? (
        <>
          <h6 className='text-sky-700 font-bold text-base'>محصولی برای نمایش وجود ندارد.</h6>
        </>
      ) : (
        <>
          {loading && products.length > 0 ? (
            <div className="skeleton-wrapper">
              <Slider {...settings}>
                {[...Array(5)].map((_, index) => (
                  <div className="item" key={index}>
                    <div className="bg-white p-2 rounded-3xl">
                      <Skeleton className='slider-skeleton rounded-xl' width="100%" />
                      <div className="px-2 mt-3">
                        <Skeleton width="80%" height="20px" className="mb-2" />
                        <Skeleton width="50%" height="20px" />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <Slider {...settings} className='product-slider'>
              {products.length > 0 && products.map(item => {
                return (
                  <div
                    className="item"
                    style={{ cursor: 'pointer' }}
                    key={item.id}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={() => handleMouseUp(item.id)}
                  >
                    <div className="bg-white p-2 product-item">
                      <img
                        className={`rounded-xl ${loaded ? 'img-loaded' : 'img-blur-placeholder'}`}
                        src={loaded ? (item.imageUrl ? imgBaseUrl + item.imageUrl : EmptyCard) : EmptyCard}
                        alt={item.title}
                        onLoad={() => setLoaded(true)} // وقتی تصویر اصلی لود شد
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = EmptyCard; // در صورت خطا، تصویر پیش‌فرض نمایش داده می‌شود
                        }}
                      />
                  <div className="px-2 mt-3">



  <div className='font-bold text-right' style={{minHeight: '40px'}}>
    <span>{convertToPersianNumbers(item.title)}</span>
  </div>
 
 

 <div className='bg-[#E5ECFF] rounded-lg w-100 flex flex-col align-items-center justify-center mt-2 py-2'>
    {item.price2 > 0 ? (
        <div className='text-blue text-lg number font-bold'>
          <span className="strikethrough-diagonal text-dark text-lg number font-bold p-2 opacity-60">
            {parseInt(item.price).toLocaleString()} 
          </span>
          {parseInt(item.price2).toLocaleString()} تومان
        </div>
    ) : (
      <div className='text-blue text-lg number'>
        {parseInt(item.price).toLocaleString()} تومان
      </div>
    )}
  </div>



</div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          )}
        </>
      )}
    </>
  );
}

export default ProductsItem;
